import { Routes } from '@angular/router';
import { AdManagerComponent, BusinessComponent, BusinessDetailComponent, DashboardComponent, LoginComponent, ScreenDetailComponent, ScreensComponent } from './pages';
import { authGuard, guestGuard } from './services';
import { Constants } from './common';

export const routes: Routes = [
    { path: Constants.APP_ROUTES.home, redirectTo: Constants.APP_ROUTES.dashboard, pathMatch: 'full' },
    { path: Constants.APP_ROUTES.login, component: LoginComponent, canActivate: [guestGuard] },
    { path: Constants.APP_ROUTES.dashboard, component: DashboardComponent, canActivate: [authGuard] },
    { path: Constants.APP_ROUTES.businessList, component: BusinessComponent, canActivate: [authGuard] },
    { path: Constants.APP_ROUTES.businessDetail(':id'), component: BusinessDetailComponent, canActivate: [authGuard] },
    { path: Constants.APP_ROUTES.adManager, component: AdManagerComponent, canActivate: [authGuard] },
    { path: Constants.APP_ROUTES.screensList, component: ScreensComponent, canActivate: [authGuard] },
    { path: Constants.APP_ROUTES.screenDetail(':id'), component: ScreenDetailComponent, canActivate: [authGuard] },
    { path: '**', redirectTo: Constants.APP_ROUTES.dashboard },
];
